import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import EfSpec from '@elem/ui/ef-spec';
import { getIsPadWidth } from '@elem/utils/devices';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import A from './home/A';
import B from './home/B';
import C from './home/C';
import D from './home/D';
import E from './home/E';
import F from './home/F';
import G from './home/G';
import css from './index.module.scss';
const SupportBanner = dynamic(() => import('@/components/SupportCommon/SupportBanner'), {
    ssr: false,
});

export default function SupportContent() {
    const { locale = 'us' } = useRouter();
    const isMobile = getIsPadWidth();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    return (
        <div className={`${css.Support} support`}>
            <div className={`${isMobile ? 'support-banner-h5' : 'support-banner-pc'}`}>
                {isMobile ? (
                    <SupportBannerH5 isSearch={true} isSupport={true} singleShow={false} titleShow={true} subTitleShow={true} isNewImg={true} />
                ) : (
                    <SupportBanner isNewImg={true} />
                )}
            </div>
            <div>
                <A />
                <B />
                <C />
                <D />
                {!['tw'].includes(locale) && <E />}
                {['uk', 'de', 'eu'].includes(locale) && <F />}
                <G />
                <EfSpec />
            </div>
        </div>
    );
}
